import { DispatchInstructionType } from './dispatch-instruction';
import { DispatchTypeLabel, RollQualityFilterOption } from './dispatch-instruction-view';

export const ROLL_QUALITY_FILTER_OPTIONS: RollQualityFilterOption[] = [
  { value: 'all', labelKey: 'Dispatch_Quality_Filter_All', fallback: 'First + B Grade' },
  { value: 'first', labelKey: 'Dispatch_Quality_Filter_First', fallback: 'First Quality' },
  { value: 'bgrade', labelKey: 'Dispatch_Quality_Filter_BGrade', fallback: 'B Grade' },
];

export const DISPATCH_TYPE_LABELS: Record<DispatchInstructionType, DispatchTypeLabel> = {
  [DispatchInstructionType.Standard]: { labelKey: 'Dispatch_Type_Standard', fallback: 'Standard' },
  [DispatchInstructionType.BGrade]: { labelKey: 'Dispatch_Type_BGrade', fallback: 'B-Grade' },
  [DispatchInstructionType.GreigeOnly]: { labelKey: 'Dispatch_Type_GreigeOnly', fallback: 'Greige Only' },
  [DispatchInstructionType.Chemical]: { labelKey: 'Dispatch_Type_Chemical', fallback: 'Chemical' },
};

// A chemical dispatch can carry many lots; the list shows this many and folds the rest into "+N".
export const MAX_VISIBLE_MANUFACTURER_LOTS = 3;

export const SCHEDULED_DATE_MONTH_NAMES: Record<string, string[]> = {
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  es: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
};
